import React from "react";
import { BsFillStarFill } from "react-icons/bs";
import TrustedMemberBadge from "../../common/trsuted-member-badge/TrustedMemberBadge";

interface SellerDetailsProps {
  sellerProfile: any;
}

function SellerDetails({ sellerProfile }: SellerDetailsProps) {
  return (
    <div className="text-center">
      <h2 className="m-0">{sellerProfile?.name}</h2>
      {sellerProfile?.verified && (
        <div className="mb-2">
          <TrustedMemberBadge />
        </div>
      )}
      <h6 className="m-0">Member since {sellerProfile?.member_since}</h6>
      <h6>
        <div className="div-link-no-decoration">
          <a href={`tel:${sellerProfile?.mobile_number}`}>
            {sellerProfile?.mobile_number}
          </a>
        </div>
      </h6>
    </div>
  );
}

export default SellerDetails;
